import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../../../../types"
import { getServiceErrorMessage } from "../../../../helpers"

export const togglePublishedTeachLiveTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "togglePublishedTeachLive",
    onDone: {
      target: "#StudyPlan.get_current_plan"
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("toggleItemTeachLive", {
            messageData: ["toggle teach live"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
